module.exports = __webpack_public_path__ + "static/publicArt-25_4-edd985c8459edf3cc4edf95e7b6b851b.jpg";